import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/components/layout'
const useLayout = () =>
    import ( /* webpackChunkName: "user" */ "@/pages/user/layout/index.vue")

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// const Index  = () => import( /* webpackChunkName: "Home" */ "@/pages/Index/index.vue");

const routes = [{
        path: '/',
        component: Layout,
        redirect: '/dcLogin',
        children: [{
                path: 'demo',
                name: 'demo',
                component: () =>
                    import ('@/pages/demo/index.vue')
            },
            {
                path: 'home',
                name: 'home',
                component: () =>
                    import ('@/pages/home/Home.vue')
            },
            {
                path: 'search',
                name: 'search',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/search')
            },
            {
                path: 'account',
                component: () =>
                    import ('@/pages/account/Account.vue'),
                redirect: '/account/accountDetail',
                children: [{
                    path: 'accountDetail',
                    name: 'AccountDetail',
                    meta: {
                        noCache: true
                    },
                    component: () =>
                        import ('@/pages/account/index/Index.vue')
                }]
            },
            {
                path: 'hot',
                component: () =>
                    import ('@/pages/hot/Hot.vue'),
                redirect: '/hot/index',
                children: [{
                        path: 'index',
                        name: 'Index',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/hot/index/Index.vue')
                    },
                    {
                        path: 'hotArticleList',
                        name: 'HotArticleList',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/hot/hotArticleList/index.vue')
                    },
                    {
                        path: 'policyArticleList',
                        name: 'PolicyArticleList',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/hot/policyArticleList')
                    },
                    {
                        path: 'policyDetail',
                        name: 'PolicyDetail',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/hot/policyDetail')
                    },
                    {
                        path: 'eventList',
                        name: 'EventList',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/hot/hotEvent/Event.vue')
                    },
                    {
                        path: '/eventList/detail',
                        name: 'EventDetail',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/hot/hotEvent/detail')
                    }
                ]
            },
            {
                path: 'landTop',
                component: () =>
                    import ('@/pages/landTop/Top.vue'),
                redirect: '/landTop/index',
                children: [{
                        path: 'index',
                        name: 'landTop',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/landTop/index/Index.vue')
                    },
                    {
                        path: 'settingCustom',
                        component: () =>
                            import ('@/pages/landTop/settingCustom/index.vue')
                    }
                ]
            },
            {
                path: 'top',
                component: () =>
                    import ('@/pages/top/Top.vue'),
                redirect: '/top/index',
                children: [{
                        path: 'index',
                        name: 'top',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/top/index/Index.vue')
                    },
                    {
                        path: 'settingCustom',
                        component: () =>
                            import ('@/pages/top/settingCustom/index.vue')
                    }
                ]
            },
            {
                path: 'rss',
                component: () =>
                    import ('@/pages/rss/Rss.vue'),
                redirect: '/rss/index',
                children: [{
                    path: 'index',
                    name: 'RssIndex',
                    meta: {
                        noCache: true
                    },
                    component: () =>
                        import ('@/pages/rss/index/Index.vue')
                }]
            },
            {
                path: 'audit',
                component: () =>
                    import ('@/pages/audit/Audit.vue'),
                // redirect: '/audit/auditIndex',
                name: 'audit',
                meta: {
                    noCache: true
                },
                children: [{
                        path: 'index',
                        name: 'auditIndex',
                        component: () =>
                            import ('@/pages/audit/index/Index.vue')
                    },
                    {
                        path: 'monitor',
                        name: 'monitor',
                        component: () =>
                            import ('@/pages/audit/monitor/Monitor.vue')
                    },
                    {
                        path: 'batchMonitor',
                        name: 'batchMonitor',
                        component: () =>
                            import ('@/pages/audit/batchMonitor/BatchMonitor.vue')
                    },
                    {
                        path: 'monitorDetail',
                        name: 'monitorDetail',
                        component: () =>
                            import ('@/pages/audit/monitorDetail/MonitorDetail.vue')
                    },
                    {
                        path: 'monitorList',
                        name: 'monitorList',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/audit/monitorList/MonitorList.vue')
                    }
                ]
            },
            {
                path: 'event',
                name: 'event',
                component: () =>
                    import ('@/pages/event/Event.vue')
            },
            {
                path: 'event/detail',
                name: 'eventDetail',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/event/detail')
            },
            {
                path: 'material',
                name: 'material',
                component: () =>
                    import ('@/pages/material/Material.vue')
            },
            {
                path: 'subject',
                component: () =>
                    import ('@/pages/subject/Subject.vue'),
                redirect: '/subject/index',
                children: [{
                        path: 'index',
                        name: 'SubjectIndex',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/subject/index/Index.vue')
                    },
                    {
                        path: 'detail',
                        name: 'subjectDetail',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/subject/detail/index.vue')
                    }
                ]
            },
            {
                path: 'resources',
                component: () =>
                    import ('@/pages/resources/Resources.vue'),
                redirect: '/resources/index',
                children: [{
                    path: 'index',
                    name: 'ResourcesIndex',
                    meta: {
                        noCache: true
                    },
                    component: () =>
                        import ('@/pages/resources/index/Index.vue')
                }]
            },
            {
                path: 'discover',
                name: 'discover',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/discover/index')
            },
            {
                path: 'contrast',
                name: 'contrast',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/contrast/Contrast.vue')
            },
            {
                path: 'generator',
                name: 'generator',
                component: () =>
                    import ('@/pages/generator/Generator.vue'),
                redirect: '/generator/index',
                meta: {
                    noCache: true
                },
                children: [{
                        path: 'index',
                        name: 'generatorIndex',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/generator/index/Index.vue')
                    },
                    // {
                    //     path: 'editor',
                    //     name: 'generatorEditor',
                    //     component: () => import('@/pages/generator/editor')
                    // },
                    // {
                    //     path: 'view',
                    //     name: 'generatorView',
                    //     component: () => import('@/pages/generator/editor/view')
                    // },
                    {
                        path: 'articleDetail',
                        name: 'articleDetail',
                        meta: {
                            noCache: true
                        },
                        component: () =>
                            import ('@/pages/generator/articleDetail/ArticleDetail.vue')
                    }
                ]
            },
            {
                path: 'brand',
                name: 'brand',
                component: () =>
                    import ('@/pages/brand/Brand.vue')
            },
            {
                path: 'calendar',
                name: 'calendar',
                component: () =>
                    import ('@/pages/calendar/Calendar.vue')
            },
            {
                path: 'profile',
                name: 'profile',
                component: () =>
                    import ('@/pages/profile/Profile.vue')
            },
            {
                path: 'leader',
                name: 'leader',
                component: () =>
                    import ('@/pages/leader/Leader.vue')
            },
            {
                path: 'notice',
                name: 'notice',
                component: () =>
                    import ('@/pages/notice/Notice.vue')
            },
            {
                path: '404',
                name: 'notFound',
                component: () =>
                    import ('@/pages/NotFound.vue')
            },
            {
                path: 'opinion',
                name: 'opinion',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/opinion')
            },
            {
                path: 'opinion/detail',
                name: 'opinionDetail',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/opinion/opinion-detail')
            },
            {
                path: '/yqStatistics',
                name: 'yqStatistics',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/yqStatistics/company')
            },
            {
                path: '/yqStatistics/project',
                name: 'yqStatisticsProject',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/yqStatistics/project')
            },
            {
                path: '/yqStatistics/addGroup',
                name: 'addGroup',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/yqStatistics/addGroup')
            },
            {
                path: '/yqStatistics/projectDetail',
                name: 'projectDetail',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/projectDetail')
            },
            {
                path: '/yqStatistics/webPhoto',
                name: 'webPhoto',
                meta: {
                    noCache: true
                },
                component: () =>
                    import ('@/pages/yqStatistics/webPhoto')
            }
        ]
    },
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ('@/pages/login/Index.vue')
    },

    // 免登陆
    {
        path: '/powersign',
        name: 'LoginPower',
        component: () =>
            import ('@/pages/login/Powersign.vue')
    },

    // 免登陆
    {
        path: '/powersignh5',
        name: 'LoginPowerH5',
        component: () =>
            import ('@/pages/login/Powersignh5.vue')
    },

    {
        path: '/dcLogin',
        name: 'DcLogin',
        component: () =>
            import ('@/pages/user/login/index.vue')
    },
    {
        path: '/main',
        name: 'main',
        component: useLayout,
        redirect: '/main/index',
        children: [{
            path: '/main/index',
            name: 'YunTuDc',
            component: () =>
                import ('@/pages/user/index/index.vue')
        }, {
            path: '/main/try',
            name: 'DcTry',
            component: () =>
                import ('@/pages/user/usesys/try.vue')
        }, {
            path: '/main/buy',
            name: 'DcBuy',
            component: () =>
                import ('@/pages/user/usesys/buy.vue')
        }, {
            path: '/main/pay',
            name: 'DcPay',
            component: () =>
                import ('@/pages/user/usesys/pay.vue')
        }, {
            path: '/main/payType',
            name: 'DcPayType',
            component: () =>
                import ('@/pages/user/usesys/payType.vue')
        }, {
            path: '/main/success',
            name: 'DcSuccess',
            component: () =>
                import ('@/pages/user/usesys/success.vue')
        }, {
            path: '/main/usercenter',
            name: 'DcUserCenter',
            component: () =>
                import ('@/pages/user/usercenter/index.vue')
        }]
    },
    {
        path: '/h5',
        name: 'h5',
        component: () =>
            import ('@/pages/h5/index'),
        redirect: '/h5/buy',
        children: [{
                path: 'buy',
                name: 'h5Buy',
                component: () =>
                    import ('@/pages/h5/buy')
            },
            {
                path: 'pay',
                name: 'h5Pay',
                component: () =>
                    import ('@/pages/h5/pay')
            },
            {
                path: 'paySuccess',
                name: 'h5PaySuccess',
                component: () =>
                    import ('@/pages/h5/paySuccess')
            },
            {
                path: 'payFail',
                name: 'h5PayFail',
                component: () =>
                    import ('@/pages/h5/payFail')
            },
            {
                path: 'login',
                name: 'h5Login',
                component: () =>
                    import ('@/pages/h5/login/login.vue'),
                redirect: '/h5/login/login',
                children: [{
                        path: 'login',
                        name: 'h5LoginItem',
                        component: () =>
                            import ('@/pages/h5/login/components/login.vue')
                    },
                    {
                        path: 'resetPassword',
                        name: 'resetPassword',
                        component: () =>
                            import ('@/pages/h5/login/components/forget.vue')
                    },
                    {
                        path: 'register',
                        name: 'register',
                        component: () =>
                            import ('@/pages/h5/login/components/register.vue')
                    }
                ]
            },
            {
                path: 'agreementFile',
                name: 'h5AgreementFile',
                component: () =>
                    import ('@/pages/h5/agreementFile/agreementFile.vue')
            }
        ]
    },
    {
        path: '*',
        redirect: '/404'
    }
]

export default new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})